import { $http } from "@/assets/js/appFunc";

export const getSettingsList = (context) => {
    if (context.state.settingsList.length === 0) {
        const req = {
            type: "GET",
            url: "/setting/all",
            data: null
        };

        $http(req).then(
            data => context.commit("setSettingsList", data),
            error => console.log(error)

        );
        console.log(context.state.settingsList);
    }
};
